<script setup lang="ts">
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ToggleSwitch from '@/components/Elements/ToggleSwitch/ToggleSwitch.vue'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerFlagsStore = usePlayerFlagsStore()

const isRingworldConstructionDefaultEnabled = computed(() => {
  return playerFlagsStore.getFlag('tutorial_ringworld_construction_default') === 'true'
})

// Toggle handler for ringworld construction default
const handleRingworldConstructionDefaultToggle = async () => {
  const newValue = isRingworldConstructionDefaultEnabled.value ? 'false' : 'true'
  await playerFlagsStore.setFlag('tutorial_ringworld_construction_default', newValue)
}
</script>

<template>
  <StandardCard :title="t('settings.ringworld.title')">
    <div class="flex justify-between items-center">
      <div>
        <p>{{ t('settings.ringworld.description') }}</p>
        <small>{{ t('settings.ringworld.hint') }}</small>
      </div>
      <div class="flex items-center pb-1">
        <ToggleSwitch
          :modelValue="isRingworldConstructionDefaultEnabled"
          @update:modelValue="handleRingworldConstructionDefaultToggle"
        />
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>